import { Stack, Typography, Box } from '@mui/material'
import type React from 'react'

import type { RequestRecommendation, SubjectData } from '@/components/Requests/types'
import type { Activity } from '@/types/Activity'

import RequestCard from './RequestCard'

interface RequestsListProps {
  title: string
  recommendations: RequestRecommendation[]
  activitiesByRecommendation: Map<string, Activity[]>
  type: 'active' | 'completed'
  emptyMessage: string
  subjectData: SubjectData
  onRequestChanged?: () => void
}

export const RequestsList: React.FC<RequestsListProps> = ({
  title,
  recommendations,
  activitiesByRecommendation,
  type,
  emptyMessage,
  subjectData,
  onRequestChanged,
}) => {
  const hasRecommendations = recommendations.length > 0

  return (
    <Stack spacing={2}>
      <Typography
        variant="h6"
        component="h3"
        sx={{ fontWeight: 600, color: '#29222a', fontSize: '18px' }}
      >
        {title}
      </Typography>

      {hasRecommendations &&
        recommendations.map(recommendation => (
          <RequestCard
            key={recommendation.id}
            recommendation={recommendation}
            activities={activitiesByRecommendation.get(recommendation.id) || []}
            type={type}
            customerId={subjectData.customerId}
            applicationId={subjectData.applicationId}
            subjectId={subjectData.subjectId}
            onRequestChanged={onRequestChanged}
          />
        ))}

      {!hasRecommendations && <Box sx={{ color: 'text.secondary' }}>{emptyMessage}</Box>}
    </Stack>
  )
}

export default RequestsList
